/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import "@/bootstrap";
import "@/plugins";
import "@/components";
import "@/layouts";

import Vue from "vue";
import App from "@/App";
import store from "@/store";
import router from "@/router";
import i18n from "@/plugins/i18n";
import VuejsDialog from "vuejs-dialog";
import MoonLoader from "vue-spinner/src/MoonLoader";
// import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js'; // only needed in custom components

// include the default style
import "vuejs-dialog/dist/vuejs-dialog.min.css";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
Vue.component("moon-loader", MoonLoader);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.config.productionTip = false;

/*Vue.config.errorHandler = (err, vm, info) => {
  Vue.rollbar.error(err);
}*/

new Vue({
  el: "#app",
  i18n,
  store,
  router,
  ...App
});
